// Change #100326 - small pieces shared by the Settings > WhatsApp tabs.
import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

import LoadingSpinner from "../../../../Components/Common/Spinner";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";

export const isOn = (v) => Number(v) === 1 || v === true;

export const channelName = (c) =>
  c ? c.DisplayName || c.UniqueIdentifier || `Channel #${c.Id}` : "";

/** Parse a JSON column that may already be an object. */
export const parseJson = (v, fallback = null) => {
  if (v === null || v === undefined || v === "") return fallback;
  if (typeof v === "object") return v;
  try {
    const parsed = JSON.parse(v);
    return parsed && typeof parsed === "object" ? parsed : fallback;
  } catch (_) {
    return fallback;
  }
};

export const DateCell = ({ value, empty = "-" }) =>
  value ? HandleDateTime(value) || <span className="text-muted">{empty}</span> : <span className="text-muted">{empty}</span>;

DateCell.propTypes = { value: PropTypes.string, empty: PropTypes.string };

export const Toolbar = ({ children, note }) => (
  <div className="wa-settings__toolbar">
    <div className="wa-settings__toolbar-note">{note}</div>
    <div className="wa-settings__toolbar-actions">{children}</div>
  </div>
);

Toolbar.propTypes = { children: PropTypes.node, note: PropTypes.node };

/** Loading spinner, empty state, or the children. */
export const ListState = ({ loading, empty, icon, title, text, action, children }) => {
  if (loading) return <LoadingSpinner />;
  if (empty) {
    return (
      <div className="wa-settings__empty">
        <i className={icon || "ri-whatsapp-line"} />
        <h5>{title}</h5>
        {text && <p className="text-muted mb-3">{text}</p>}
        {action}
      </div>
    );
  }
  return children;
};

ListState.propTypes = {
  loading: PropTypes.bool,
  empty: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.node,
  text: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
};

/** Bootstrap switch, value 1/0. */
export const Switch = ({ id, checked, onChange, label, disabled }) => (
  <div className="form-check form-switch mb-0">
    <Input
      id={id}
      type="checkbox"
      role="switch"
      className="form-check-input"
      checked={!!checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked ? 1 : 0)}
    />
    {label && (
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    )}
  </div>
);

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  disabled: PropTypes.bool,
};

export const ActiveBadge = ({ active }) =>
  isOn(active) ? (
    <span className="badge bg-success-subtle text-success">Active</span>
  ) : (
    <span className="badge bg-secondary-subtle text-secondary">Inactive</span>
  );

ActiveBadge.propTypes = { active: PropTypes.any };

export const FieldHelp = ({ children }) => <div className="form-text">{children}</div>;

FieldHelp.propTypes = { children: PropTypes.node };
